import React, { useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { usePermissions } from "./PermissionContext";

const RestrictedRoute = ({ permission, children, ...rest }) => {
  const { permissions = [], loading, userInfo } = usePermissions();
  const location = useLocation();
  const isSuperAdmin = userInfo?.role_permission?.[0]?.role === "super admin";
  const hasAccess = permissions.some(
    (p) => p.permission_name === permission && p.is_accessible,
  );

  // Keep hooks before any early return.
  useEffect(() => {
    if (!loading && (hasAccess || isSuperAdmin)) {
      sessionStorage.setItem(
        "lastAccessiblePath",
        `${location.pathname}${location.search || ""}`,
      );
    }
  }, [loading, hasAccess, isSuperAdmin, location.pathname, location.search]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isSuperAdmin) {
    return <Route {...rest}>{children}</Route>;
  }

  return (
    <Route
      {...rest}
      render={() =>
        hasAccess ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/AccessDeniedPage",
              state: {
                deniedPath: `${location.pathname}${location.search || ""}`,
                fallbackPath:
                  sessionStorage.getItem("lastAccessiblePath") || "/login",
              },
            }}
          />
        )
      }
    />
  );
};

export default RestrictedRoute;
